import { MutationTree } from 'vuex';
import animations from '../animations';

export const mutations = {
    setCurrentAnimation(state, animation) {
        state.currentAnimation = animation
    },
    setAnimations(state, animations) {
        state.animations = animations
    }
};